import { render } from "./Records.vue?vue&type=template&id=3ea168aa&scoped=true&ts=true"
import script from "./Records.vue?vue&type=script&lang=ts"
export * from "./Records.vue?vue&type=script&lang=ts"

import "./Records.vue?vue&type=style&index=0&id=3ea168aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea168aa"]])

export default __exports__